import axios, { AxiosError } from "axios";
import qs from "qs";
import Auth from "../services/auth/AuthService";

const api = axios.create({
    baseURL: process.env.REACT_APP_GARBAGECAN_API,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    config.paramsSerializer = (params) => qs.stringify(params);
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        const message = error.response?.data as string;
        if (error.response?.status === 401) {
            Auth.setAuth(undefined);
        }
        if (message) {
            console.error(error);
        }
        return error;
    }
);

export default api;
